import React from 'react';
import * as S from './YouTubeEmbed.styles';

const YouTubeEmbed = ({ videoId, title = 'Video promocional' }) => {
  return (
    <S.VideoContainer>
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title={title}
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
      />
    </S.VideoContainer>
  );
};

export default YouTubeEmbed;
